import { FormControl, Grid, IconButton, InputLabel, Select, TextField, Box } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { Search as IconSearch } from "@mui/icons-material";
import { FormHelperText as HelperText } from '@mui/material';

import { init, setEntity, setData, setListCargo, setValidationMessage } from "../redux/trabajadorSlice";
import * as catalogoService from "../services/catalogoService";
import trabajadorService from "../services/trabajadorService";
import PersonSearch from './PersonSearch';

// Catalogo de tipos de cargo del personal: terapeuta, secretaria, personal de
// limpieza, director, coordinador, etc.
const CATALOGO_TIPOS_CARGO = 236;

// Formulario del personal. La persona es una persona natural ya registrada.
const Trabajador = (props) => {
    const isReadOnly = props.isReadOnly;
    const sliceKey = props.sliceKey;
    const params = useParams();
    const dispatch = useDispatch();

    const entity = useSelector((state) => state.trabajador[sliceKey]?.entity) || {};
    const listCargo = useSelector((state) => state.trabajador[sliceKey]?.listCargo) || [];
    const validate = useSelector((state) => state.trabajador[sliceKey]?.validationActive) || {};

    const [openSearchPersona, setOpenSearchPersona] = React.useState(false);
    const openCloseSearchPersona = () => { setOpenSearchPersona(!openSearchPersona) };

    const validation = {
        idPersona: {
            error: !entity.idPersona || entity.idPersona == 0,
            message: "Seleccione a la persona del personal",
        },
        idCargo: {
            error: !entity.idCargo || entity.idCargo == 0,
            message: "Seleccione el cargo",
        },
    }

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    useEffect(() => {
        dispatch(init({ sliceKey: sliceKey }));
    }, [dispatch, sliceKey])

    const fetchEntity = useCallback(async () => {
        if (!params.id || params.id == 0) return;

        const response = await trabajadorService.getTrabajadorView(params.id)
            .catch((err) => { console.log("Err: ", err) });

        // La vista devuelve el id del trabajador en "id" y el nombre en "nombres".
        if (response) {
            dispatch(setEntity({ sliceKey: sliceKey, data: {
                ...response,
                idTrabajador: response.id,
                persona: response.nombres || "",
            } }));
        }
    }, [params.id])

    const fetchListCargo = useCallback(async () => {
        const data = await catalogoService.getCatalogosByPadre(CATALOGO_TIPOS_CARGO)
            .catch((err) => { console.log("Err: ", err) });

        dispatch(setListCargo({ sliceKey: sliceKey, data: data || [] }));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchListCargo();
    }, [])

    useEffect(() => {
        dispatch(setValidationMessage({ sliceKey: sliceKey, message: messagesValidation() }));
    }, [entity])

    const setSelectSearchPersona = (select) => {
        dispatch(setData({ sliceKey: sliceKey, name: "idPersona", value: select.id }));
        dispatch(setData({ sliceKey: sliceKey, name: "persona", value: select.nombres }));
        dispatch(setData({ sliceKey: sliceKey, name: "tipoDocumento", value: select.tipoDocumento || "" }));
        dispatch(setData({ sliceKey: sliceKey, name: "numeroDocumento", value: select.numeroDocumento || "" }));
    }

    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    Datos del Personal
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={12} sm={4}>
                    <Box display="flex" alignItems="center" gap={0}>
                        <TextField
                            required
                            disabled
                            name="persona"
                            label="Persona"
                            fullWidth
                            value={entity?.persona || ""}
                            error={validate.idPersona && validation.idPersona.error}
                            helperText={validate.idPersona && validation.idPersona.error ? validation.idPersona.message : ""}
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                        <IconButton aria-label="buscar persona" size="small" disabled={isReadOnly} onClick={openCloseSearchPersona}>
                            <IconSearch />
                        </IconButton>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        disabled
                        name="numeroDocumento"
                        label="Num. Documento"
                        fullWidth
                        value={entity?.numeroDocumento || ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        required
                        name="seudonimo"
                        label="Seudonimo"
                        fullWidth
                        value={entity?.seudonimo || ""}
                        onChange={(event) => dispatch(setData({ sliceKey: sliceKey, name: "seudonimo", value: event.target.value }))}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <FormControl required fullWidth error={validate.idCargo && validation.idCargo.error}>
                        <InputLabel htmlFor="input-cargo">Cargo</InputLabel>
                        <Select
                            native
                            label="Cargo"
                            value={entity?.idCargo || 0}
                            onChange={(event) => dispatch(setData({ sliceKey: sliceKey, name: "idCargo", value: event.target.value }))}
                            inputProps={{ name: 'idCargo', id: 'input-cargo' }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listCargo.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idCargo && validation.idCargo.error ? validation.idCargo.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        name="fechaIngreso"
                        label="Fecha Ingreso"
                        type="date"
                        fullWidth
                        value={moment(entity?.fechaIngreso || moment()).format('yyyy-MM-DD')}
                        onChange={(event) => dispatch(setData({ sliceKey: sliceKey, name: "fechaIngreso", value: event.target.value }))}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="input-estado">Estado</InputLabel>
                        <Select
                            native
                            label="Estado"
                            value={entity?.idEstado || 0}
                            onChange={(event) => dispatch(setData({ sliceKey: sliceKey, name: "idEstado", value: event.target.value }))}
                            inputProps={{ name: 'idEstado', id: 'input-estado' }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={2} value={2}>{"Activo"}</option>
                            <option key={3} value={3}>{"Inactivo"}</option>
                            <option key={4} value={4}>{"Anulado"}</option>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <PersonSearch open={openSearchPersona} openClose={openCloseSearchPersona} setSelection={setSelectSearchPersona} />
        </Grid>
    )
}

export default Trabajador;